export default __webpack_public_path__ + "static/media/wotfard-light-webfont.ae7cce29.woff2";